export const STATUSES_PAST_INTAKE = [
  "VEHICLE_RECEIVED_AT_WORKSHOP","WORKSHOP_ESTIMATE","ESTIMATE_APPROVED",
  "CLAIM_FORM_SENT_TO_CUSTOMER","CLAIM_FORM_SIGNED","CLAIM_FORM_APPROVED",
  "CLAIM_SUBMITTED","WORKSHOP_SURVEY_ASSIGNED","WORKSHOP_SURVEY_COMPLETED",
  "DISMANTLING_APPROVED","DISMANTLING_COMPLETED","SECOND_SURVEY_ASSIGNED",
  "SECOND_SURVEY_COMPLETED","REPAIR_APPROVED","REPAIR_STARTED","REPAIR_COMPLETED",
  "VEHICLE_FINALIZED","READY_FOR_REINSPECTION","REINSPECTION_COMPLETED",
  "PROFORMA_UPLOADED","PROFORMA_RECEIVED","ASSESSMENT_RECEIVED","ASSESSMENT_CROSSCHECKED","TAX_INVOICE_RECEIVED","PAYMENT_REQUEST_SENT",
  "PAYMENT_COMPLETED","CLAIM_SETTLED","CASE_CLOSED",
];
 
export const STATUSES_PAST_ESTIMATE_APPROVED = [
  "CLAIM_FORM_SENT_TO_CUSTOMER","CLAIM_FORM_SIGNED","CLAIM_FORM_APPROVED",
  "CLAIM_SUBMITTED","WORKSHOP_SURVEY_ASSIGNED","WORKSHOP_SURVEY_COMPLETED",
  "DISMANTLING_APPROVED","DISMANTLING_COMPLETED","SECOND_SURVEY_ASSIGNED",
  "SECOND_SURVEY_COMPLETED","REPAIR_APPROVED","REPAIR_STARTED","REPAIR_COMPLETED",
  "VEHICLE_FINALIZED","READY_FOR_REINSPECTION","REINSPECTION_COMPLETED",
  "PROFORMA_UPLOADED","PROFORMA_RECEIVED","ASSESSMENT_RECEIVED","ASSESSMENT_CROSSCHECKED","TAX_INVOICE_RECEIVED","PAYMENT_REQUEST_SENT",
  "PAYMENT_COMPLETED","CLAIM_SETTLED","CASE_CLOSED",
];
 
export const STATUSES_PAST_CLAIM_UPLOADED = [
  "CLAIM_FORM_SIGNED","CLAIM_FORM_APPROVED","CLAIM_SUBMITTED",
  "WORKSHOP_SURVEY_ASSIGNED","WORKSHOP_SURVEY_COMPLETED",
  "DISMANTLING_APPROVED","DISMANTLING_COMPLETED","SECOND_SURVEY_ASSIGNED",
  "SECOND_SURVEY_COMPLETED","REPAIR_APPROVED","REPAIR_STARTED","REPAIR_COMPLETED",
  "VEHICLE_FINALIZED","READY_FOR_REINSPECTION","REINSPECTION_COMPLETED",
  "PROFORMA_UPLOADED","PROFORMA_RECEIVED","ASSESSMENT_RECEIVED","ASSESSMENT_CROSSCHECKED","TAX_INVOICE_RECEIVED","PAYMENT_REQUEST_SENT",
  "PAYMENT_COMPLETED","CLAIM_SETTLED","CASE_CLOSED",
];
 
export const STATUSES_PAST_CUSTOMER_SIGNED = [
  "CLAIM_FORM_APPROVED","CLAIM_SUBMITTED",
  "WORKSHOP_SURVEY_ASSIGNED","WORKSHOP_SURVEY_COMPLETED",
  "DISMANTLING_APPROVED","DISMANTLING_COMPLETED","SECOND_SURVEY_ASSIGNED",
  "SECOND_SURVEY_COMPLETED","REPAIR_APPROVED","REPAIR_STARTED","REPAIR_COMPLETED",
  "VEHICLE_FINALIZED","READY_FOR_REINSPECTION","REINSPECTION_COMPLETED",
  "PROFORMA_UPLOADED","PROFORMA_RECEIVED","ASSESSMENT_RECEIVED","ASSESSMENT_CROSSCHECKED","TAX_INVOICE_RECEIVED","PAYMENT_REQUEST_SENT",
  "PAYMENT_COMPLETED","CLAIM_SETTLED","CASE_CLOSED",
];
 
export const STATUSES_PAST_CLAIM_APPROVED = [
  "CLAIM_SUBMITTED","WORKSHOP_SURVEY_ASSIGNED","WORKSHOP_SURVEY_COMPLETED",
  "DISMANTLING_APPROVED","DISMANTLING_COMPLETED","SECOND_SURVEY_ASSIGNED",
  "SECOND_SURVEY_COMPLETED","REPAIR_APPROVED","REPAIR_STARTED","REPAIR_COMPLETED",
  "VEHICLE_FINALIZED","READY_FOR_REINSPECTION","REINSPECTION_COMPLETED",
  "PROFORMA_UPLOADED","PROFORMA_RECEIVED","ASSESSMENT_RECEIVED","ASSESSMENT_CROSSCHECKED","TAX_INVOICE_RECEIVED","PAYMENT_REQUEST_SENT",
  "PAYMENT_COMPLETED","CLAIM_SETTLED","CASE_CLOSED",
];
 
export const STATUSES_PAST_CLAIM_SENT = [
  "WORKSHOP_SURVEY_ASSIGNED","WORKSHOP_SURVEY_COMPLETED",
  "DISMANTLING_APPROVED","DISMANTLING_COMPLETED","SECOND_SURVEY_ASSIGNED",
  "SECOND_SURVEY_COMPLETED","REPAIR_APPROVED","REPAIR_STARTED","REPAIR_COMPLETED",
  "VEHICLE_FINALIZED","READY_FOR_REINSPECTION","REINSPECTION_COMPLETED",
  "PROFORMA_UPLOADED","PROFORMA_RECEIVED","ASSESSMENT_RECEIVED","ASSESSMENT_CROSSCHECKED","TAX_INVOICE_RECEIVED","PAYMENT_REQUEST_SENT",
  "PAYMENT_COMPLETED","CLAIM_SETTLED","CASE_CLOSED",
];

export const STATUS_TO_ACTION = {
  // Intake phase
  WORKSHOP_ASSIGNED:              "vehicle_picked",
  VEHICLE_PICKED:                 "vehicle_received",
  VEHICLE_RECEIVED_AT_WORKSHOP:   "estimate",
  WORKSHOP_ESTIMATE:              "estimate",
 
  // Estimate approval
  ESTIMATE_APPROVED:              "claim",
 
  // Claim form phase
  CLAIM_FORM_SENT_TO_CUSTOMER:    "claim",
  CLAIM_FORM_SIGNED:              "claim",   // still on claim — need admin to approve
  CLAIM_FORM_APPROVED:            "claim",   // still on claim — need admin to send
 
  // Past claim — advance to surveyor
  CLAIM_SUBMITTED:                "surveyor",
  WORKSHOP_SURVEY_ASSIGNED:       "surveyor",
 
  // Past surveyor — dismantling
  WORKSHOP_SURVEY_COMPLETED:      "dismantling_approval",
 
  // Dismantling
  DISMANTLING_APPROVED:           "dismantling_done",
  DISMANTLING_COMPLETED:          "second_visit",
 
  // Second survey
  SECOND_SURVEY_ASSIGNED:         "second_survey",
  SECOND_SURVEY_COMPLETED:        "final_approval",
 
  // Repair
  REPAIR_APPROVED:                "work_started",
  REPAIR_STARTED:                 "truck_repaired",
  REPAIR_COMPLETED:               "reinspection",
  VEHICLE_FINALIZED:              "reinspection",
  READY_FOR_REINSPECTION:         "reinspection",
 
  // Reinspection → proforma
  REINSPECTION_COMPLETED:         "proforma",
  WAITING_FOR_PROFORMA:           "proforma",
  PROFORMA_UPLOADED:              "proforma",
 
  // Post-proforma workflow
  PROFORMA_RECEIVED:              "assessment",
  ASSESSMENT_RECEIVED:            "crosscheck",
  ASSESSMENT_CROSSCHECKED:        "tax_invoice",
  TAX_INVOICE_RECEIVED:           "payments",

  // Done
  // PAYMENT_REQUEST_SENT:           "payments_received",
  PAYMENT_COMPLETED:              "settle_claim",
  CLAIM_SETTLED:                  "close_case",
  CASE_CLOSED:                    "complete",
};

export const STATUSES_AT_OR_PAST_ESTIMATE_APPROVED = [
  "ESTIMATE_APPROVED","CLAIM_FORM_SENT_TO_CUSTOMER","CLAIM_FORM_SIGNED",
  "CLAIM_FORM_APPROVED","CLAIM_SUBMITTED","WORKSHOP_SURVEY_ASSIGNED",
  "WORKSHOP_SURVEY_COMPLETED","DISMANTLING_APPROVED","DISMANTLING_COMPLETED",
  "SECOND_SURVEY_ASSIGNED","SECOND_SURVEY_COMPLETED","REPAIR_APPROVED",
  "REPAIR_STARTED","REPAIR_COMPLETED","VEHICLE_FINALIZED","READY_FOR_REINSPECTION",
  "REINSPECTION_COMPLETED","PROFORMA_UPLOADED","PROFORMA_RECEIVED","ASSESSMENT_RECEIVED","ASSESSMENT_CROSSCHECKED","TAX_INVOICE_RECEIVED",
  "PAYMENT_REQUEST_SENT","PAYMENT_COMPLETED","CLAIM_SETTLED","CASE_CLOSED",
];
 
export const STATUSES_AT_OR_PAST_CLAIM_SENT = [
  "CLAIM_SUBMITTED","WORKSHOP_SURVEY_ASSIGNED","WORKSHOP_SURVEY_COMPLETED",
  "DISMANTLING_APPROVED","DISMANTLING_COMPLETED","SECOND_SURVEY_ASSIGNED",
  "SECOND_SURVEY_COMPLETED","REPAIR_APPROVED","REPAIR_STARTED","REPAIR_COMPLETED",
  "VEHICLE_FINALIZED","READY_FOR_REINSPECTION","REINSPECTION_COMPLETED",
  "PROFORMA_UPLOADED","PROFORMA_RECEIVED","ASSESSMENT_RECEIVED","ASSESSMENT_CROSSCHECKED","TAX_INVOICE_RECEIVED","PAYMENT_REQUEST_SENT",
  "PAYMENT_COMPLETED","CLAIM_SETTLED","CASE_CLOSED",
];
 
export const STATUSES_AT_OR_PAST_SURVEYOR_ASSIGNED = [
  "WORKSHOP_SURVEY_ASSIGNED","WORKSHOP_SURVEY_COMPLETED",
  "DISMANTLING_APPROVED","DISMANTLING_COMPLETED","SECOND_SURVEY_ASSIGNED",
  "SECOND_SURVEY_COMPLETED","REPAIR_APPROVED","REPAIR_STARTED","REPAIR_COMPLETED",
  "VEHICLE_FINALIZED","READY_FOR_REINSPECTION","REINSPECTION_COMPLETED",
  "PROFORMA_UPLOADED","PROFORMA_RECEIVED","ASSESSMENT_RECEIVED","ASSESSMENT_CROSSCHECKED","TAX_INVOICE_RECEIVED","PAYMENT_REQUEST_SENT",
  "PAYMENT_COMPLETED","CLAIM_SETTLED","CASE_CLOSED",
];
 
export const STATUSES_AT_OR_PAST_DISMANTLING_APPROVED = [
  "DISMANTLING_APPROVED","DISMANTLING_COMPLETED","SECOND_SURVEY_ASSIGNED",
  "SECOND_SURVEY_COMPLETED","REPAIR_APPROVED","REPAIR_STARTED","REPAIR_COMPLETED",
  "VEHICLE_FINALIZED","READY_FOR_REINSPECTION","REINSPECTION_COMPLETED",
  "PROFORMA_UPLOADED","PROFORMA_RECEIVED","ASSESSMENT_RECEIVED","ASSESSMENT_CROSSCHECKED","TAX_INVOICE_RECEIVED","PAYMENT_REQUEST_SENT",
  "PAYMENT_COMPLETED","CLAIM_SETTLED","CASE_CLOSED",
];
 
export const STATUSES_AT_OR_PAST_DISMANTLING_COMPLETED = [
  "DISMANTLING_COMPLETED","SECOND_SURVEY_ASSIGNED","SECOND_SURVEY_COMPLETED",
  "REPAIR_APPROVED","REPAIR_STARTED","REPAIR_COMPLETED","VEHICLE_FINALIZED",
  "READY_FOR_REINSPECTION","REINSPECTION_COMPLETED","WAITING_FOR_PROFORMA",
  "PROFORMA_RECEIVED","ASSESSMENT_RECEIVED","ASSESSMENT_CROSSCHECKED","TAX_INVOICE_RECEIVED","PAYMENT_REQUEST_SENT","PAYMENT_COMPLETED",
  "CLAIM_SETTLED","CASE_CLOSED",
];
 
export const STATUSES_AT_OR_PAST_SECOND_SURVEY = [
  "SECOND_SURVEY_COMPLETED","REPAIR_APPROVED","REPAIR_STARTED","REPAIR_COMPLETED",
  "VEHICLE_FINALIZED","READY_FOR_REINSPECTION","REINSPECTION_COMPLETED",
  "PROFORMA_UPLOADED","PROFORMA_RECEIVED","ASSESSMENT_RECEIVED","ASSESSMENT_CROSSCHECKED","TAX_INVOICE_RECEIVED","PAYMENT_REQUEST_SENT",
  "PAYMENT_COMPLETED","CLAIM_SETTLED","CASE_CLOSED",
];
 
export const STATUSES_AT_OR_PAST_FINAL_APPROVED = [
  "REPAIR_APPROVED","REPAIR_STARTED","REPAIR_COMPLETED","VEHICLE_FINALIZED",
  "READY_FOR_REINSPECTION","REINSPECTION_COMPLETED","WAITING_FOR_PROFORMA",
  "PROFORMA_RECEIVED","ASSESSMENT_RECEIVED","ASSESSMENT_CROSSCHECKED","TAX_INVOICE_RECEIVED","PAYMENT_REQUEST_SENT","PAYMENT_COMPLETED",
  "CLAIM_SETTLED","CASE_CLOSED",
];
 
export const STATUSES_AT_OR_PAST_WORK_STARTED = [
  "REPAIR_STARTED","REPAIR_COMPLETED","VEHICLE_FINALIZED","READY_FOR_REINSPECTION",
  "REINSPECTION_COMPLETED","PROFORMA_UPLOADED","PROFORMA_RECEIVED","ASSESSMENT_RECEIVED","ASSESSMENT_CROSSCHECKED","TAX_INVOICE_RECEIVED",
  "PAYMENT_REQUEST_SENT","PAYMENT_COMPLETED","CLAIM_SETTLED","CASE_CLOSED",
];
 
export const STATUSES_AT_OR_PAST_TRUCK_REPAIRED = [
  "REPAIR_COMPLETED","VEHICLE_FINALIZED","READY_FOR_REINSPECTION",
  "REINSPECTION_COMPLETED","PROFORMA_UPLOADED","PROFORMA_RECEIVED","ASSESSMENT_RECEIVED","ASSESSMENT_CROSSCHECKED","TAX_INVOICE_RECEIVED",
  "PAYMENT_REQUEST_SENT","PAYMENT_COMPLETED","CLAIM_SETTLED","CASE_CLOSED",
];
 
export const STATUSES_AT_OR_PAST_REINSPECTION = [
  "REINSPECTION_COMPLETED","PROFORMA_UPLOADED","PROFORMA_RECEIVED","ASSESSMENT_RECEIVED","ASSESSMENT_CROSSCHECKED","TAX_INVOICE_RECEIVED",
  "PAYMENT_REQUEST_SENT","PAYMENT_COMPLETED","CLAIM_SETTLED","CASE_CLOSED",
];

// ─── Up next descriptions ─────────────────────────────────────────────────────
export const UP_NEXT = {
  vehicle_picked:   ["Mark vehicle received at workshop", "Workshop intake & estimate", "Claim form draft → customer signs → approve → send to insurer"],
  vehicle_received: ["Workshop intake & estimate", "Claim form draft → customer signs → approve → send to insurer", "Assign workshop surveyor"],
  estimate:         ["Claim form — upload draft → customer signs → approve → send to insurer", "Assign workshop surveyor (after insurer responds)", "Dismantling approval → dismantling completed → 2nd visit…"],
  surveyor:             ["Dismantling approval", "Dismantling completed", "2nd workshop visit → 2nd survey → final approval…"],
  dismantling_approval: ["Dismantling completed", "2nd workshop visit assigned", "2nd survey → final approval → work started…"],
  dismantling_done:     ["2nd workshop visit assigned", "2nd survey done", "Final approval → work started → truck repaired…"],
  second_visit:         ["2nd survey done", "Final approval to start work", "Work started → truck repaired → reinspection…"],
  second_survey:        ["Final approval to start work", "Work started", "Truck repaired → reinspection → proforma…"],
  final_approval:       ["Work started", "Truck repaired", "Reinspection → proforma invoice → assessment → tax invoice"],
  work_started:         ["Truck repaired", "Reinspection done", "Proforma invoice upload"],
  truck_repaired:       ["Reinspection done", "Proforma invoice upload"],
  reinspection:         ["Proforma invoice upload"],
  proforma:             ["Assessment received", "Assessment crosschecked", "Tax invoice received"],
  assessment:           ["Assessment crosschecked", "Tax invoice received", "Submit payment request"],
  crosscheck:           ["Tax invoice received", "Submit payment request", "Complete payment"],
  tax_invoice:          ["Payment request sent", "Payment completed", "Claim settled"],
  payments:           ["Mark all payments received", "Settle claim", "Close case"],
  payments_received:  ["Settle claim", "Close case"],
  settle_claim:       ["Close case"],
  close_case:         [],
  complete:           [],
};